"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _select = _interopRequireDefault(require("../select"));

var _avatar = _interopRequireDefault(require("../avatar"));

var _switch = _interopRequireDefault(require("../switch"));

require("./styles.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaderBoard(_ref) {
  var users = _ref.users,
      _ref$filter = _ref.filter,
      title = _ref$filter.title,
      options = _ref$filter.options,
      placeholder = _ref$filter.placeholder;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "leader-board-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "heading"
  }, " Leaderboard "), /*#__PURE__*/_react.default.createElement("div", {
    className: "filters"
  }, /*#__PURE__*/_react.default.createElement("label", null, " ", title, " "), /*#__PURE__*/_react.default.createElement(_select.default, {
    options: options,
    placeholder: placeholder,
    type: _select.default.TYPE.DEFAULT
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "leader-board-list"
  }, users.map(function (_ref2) {
    var id = _ref2.id,
        image = _ref2.image,
        name = _ref2.name,
        count = _ref2.count,
        backgroundColor = _ref2.color,
        isActive = _ref2.isActive;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "leader-board-list-item",
      key: id
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_avatar.default, {
      src: image,
      size: "medium"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "name"
    }, " ", name, " ")), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_switch.default, {
      value: isActive
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "count"
    }, " ", count, " "), /*#__PURE__*/_react.default.createElement("span", {
      className: "badge",
      style: {
        backgroundColor: backgroundColor
      }
    })));
  })));
}

LeaderBoard.propTypes = {
  users: _propTypes.default.array.isRequired,
  filter: _propTypes.default.object.isRequired
};
var _default = LeaderBoard;
exports.default = _default;